import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02229ce6&"
import script from "./home/index.js?vue&type=script&lang=js&"
export * from "./home/index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=02229ce6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports